import React, { ReactNode } from 'react';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type BetslipModalHeaderProps = {
    title: string;
    description?: string;
    children?: ReactNode;
};

export const BetslipModalHeader = ({ title, description, children }: BetslipModalHeaderProps) => (
    <Box px="s8" pt="s32" pb="s24" alignItems="center" gap="s8">
        <Text variant="headlineMedium" color={ds.colorToken.text.primary} lineHeight={28}>
            {title}
        </Text>
        {description ? (
            <Text variant="bodyMedium" color="neutral300" textAlign="center">
                {description}
            </Text>
        ) : null}
        {children}
    </Box>
);
